// The line a suspended account sees on this device (app/auth/me.ts,
// pausedStore): sync has stopped, nothing on the device was touched, and
// the words say so. Shown over whatever screen is open until the server
// next names the person; it never asks them to sign in again.
import { Banner } from '@app/ui';
import { usePaused } from './me';
import './paused.css';

export const PAUSED_WORDS = 'This account is paused. Your projects are safe on this device.';

export function PausedBanner() {
  const paused = usePaused();
  if (!paused) return null;
  return (
    <div className="paused-banner">
      <Banner tone="warn" icon="pause">
        {PAUSED_WORDS} <a href="/legal">Contact us.</a>
      </Banner>
    </div>
  );
}
